import axios, { AxiosError, AxiosResponse } from 'axios'
import app_config from 'config/app_config'
import { AUTH } from 'constants/localStorageKeys'
import { defaults, isObject, isEmpty } from 'lodash'
import paths from 'navigation/paths'
import { IApiMiddleware } from './types'

const baseURL = app_config.env.REACT_APP_BASE_URL

export default function apiMiddleware({
	url = '/',
	method = 'GET',
	data = {},
	headers = {},
	transform = true,
	contentType = 'application/json',
	responseType = 'json',
}: IApiMiddleware): Promise<any> {
	defaults(headers, {
		Accept: `${contentType}; charset=UTF-8`,
		'Content-Type': `${contentType}; charset=UTF-8`,
		Authorization: `Bearer ${localStorage.getItem(AUTH)}`, // add your locale storage item name
	})

	return axios({
		baseURL,
		method,
		url,
		headers,
		responseType,
		withCredentials: true,
		params: method === 'GET' && isObject(data) && !isEmpty(data) ? data : {},
		data: transform ? JSON.stringify(data) : data,
	})
		.then((resp: AxiosResponse) => resp.data)
		.catch((er: AxiosError<any>) => {
			if (er?.response?.status === 401) {
				localStorage.removeItem(AUTH)
				window.location.href = `${paths.signIn}?path=${window.location.pathname}`
			}

			const error = er?.response?.data.message
			const spareMessage = 'Something went wrong'
			throw new Error(error || spareMessage)
		})
}
